import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApplicationLandingComponent } from './components/application-landing/application-landing.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { SidebarMainComponent } from './components/sidebar-main/sidebar-main.component';
import { UnsubscribeCommunicationsComponent } from './components/unsubscribe-communications/unsubscribe-communications.component';
import { UserCancelationComponent } from './components/user-cancelation/user-cancelation.component';
import { AuthGuard } from './guards/auth.guard';
import { GoodByeGuard } from './guards/good-bye.guard';
import { UserValidationResolver } from './services/user-validation.resolver';

const routes: Routes = [
  {
    path: '',
    component: SidebarMainComponent,
    children: [
      {
        path: 'info',
        loadChildren: () =>
          import('../modules/info/info.module').then(m => m.InfoModule)
      },
      {
        path: 'privacy',
        loadChildren: () =>
          import('../modules/privacy/privacy.module').then(m => m.PrivacyModule)
      },
      {
        path: '',
        loadChildren: () =>
          import('../modules/home/home.module').then(m => m.HomeModule)
      }
    ],
    canActivate: [AuthGuard],
    resolve: { user: UserValidationResolver }
  },
  {
    path: 'application-landing',
    component: ApplicationLandingComponent
  },
  {
    path: 'good-bye',
    component: UserCancelationComponent,
    canActivate: [GoodByeGuard]
  },
  {
    path: 'unsubscribe-communications',
    component: UnsubscribeCommunicationsComponent
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class CoreRoutingModule {}
